import { Injectable } from '@angular/core';
import { Auth0Client } from '@auth0/auth0-spa-js';

type Auth0ConfigEnvironment = 'production' | 'staging' | 'development';
interface Auth0Config {
  domain: string;
  clientId: string;
  hostNames: string[];
}

export const AUTH0_CONFIG: Record<Auth0ConfigEnvironment, Auth0Config> = {
  production: {
    domain: 'auth.49ing.ch',
    clientId: 'CR79VmjedmA36uHzdt2ueD2n7LUsIA1U',
    hostNames: ['collection.49ing.ch', '49ing-data-collector.appengine.flow.ch']
  },
  staging: {
    domain: '49ing-staging.eu.auth0.com',
    clientId: 'Wa6vHKisQceBiXKM0XX1a2PgoB5JWcOW',
    hostNames: [
      'collection-test.49ing.ch',
      '49ing-data-collection-test-docker.appengine.flow.ch'
    ]
  },
  development: {
    domain: '49ing-dev.eu.auth0.com',
    clientId: 'FUIszq2DAuuKSGPRjpyb83AIi5kvzJLL',
    hostNames: ['localhost']
  }
};

@Injectable({
  providedIn: 'root'
})
export class Auth0ClientService {
  constructor() {}

  public createAuth0Client() {
    console.log('creating Auth0 client...');

    const auth0Config = this.deriveConfigFromHostName(window.location.hostname);
    return new Auth0Client({
      domain: auth0Config.domain,
      client_id: auth0Config.clientId,
      audience: 'https://data-collection.49ing.ch/v1/',
      responseType: 'token id_token',
      redirect_uri: window.location.origin + '/auth0-callback',
      scope:
        'openid profile read:teams read:players read:games write:games read:events write:events',
      cacheLocation: 'localstorage',
      useRefreshTokens: true
    });
  }

  deriveConfigFromHostName(hostName: string): Auth0Config {
    const configEntry = Object.entries(AUTH0_CONFIG).find(([_key, value]) =>
      value.hostNames.includes(hostName)
    );

    if (configEntry) {
      console.log(
        `Auth0 configuration '${configEntry[0]}' found for host name '${hostName}'`
      );
      return configEntry[1];
    } else {
      console.warn(
        `No Auth0 configuration found for host name '${hostName}' - using development config`
      );
      return AUTH0_CONFIG.development;
    }
  }
}
